import axios from 'axios';
import Swal from 'sweetalert2';
import { getId } from '../../User';

function handleResponse(t, router, url, jsonString, back, success, failure) {
  const dataObject = jsonString ? JSON.parse(jsonString) : {};
  dataObject.user_id = getId();
  const data = JSON.stringify(dataObject);
  return axios
    .post(url, data)
    .then((response) => {
      if (response.data.success) {
        if (router && back) {
          router.push(back);
        }
        if (success) {
          Swal.fire({
            title: t(success),
            icon: 'success',
          });
        }
      } else {
        console.error(response);
        Swal.fire({
          title: t(failure),
          icon: 'error',
        });
      }
      return response;
    })
    .catch((error) => {
      console.error('There was an error insert the data:', error);
      Swal.fire({
        title: t(failure),
        icon: 'error',
      });
      return null;
    });
}

function handleResponseWithFile(t, router, url, jsonString, back, success, failure, file) {
  const formData = new FormData();
  if (jsonString) {
    const dataObject = JSON.parse(jsonString);
    dataObject.user_id = getId();

    Object.keys(dataObject).forEach((key) => {
      formData.append(key, dataObject[key]);
    });
  }

  if (file) {
    formData.append('file', file);
  }
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };

  return axios
    .post(url, formData, config)
    .then((response) => {
      if (response.data.success) {
        if (router && back) {
          router.push(back);
        }
        if (success) {
          Swal.fire({
            title: t(success),
            icon: 'success',
          });
        }
      } else {
        console.error(response);
        Swal.fire({
          title: t(failure),
          icon: 'error',
        });
      }
      return response;
    })
    .catch((error) => {
      console.error('There was an error inserting the data:', error);
      Swal.fire({
        title: t(failure),
        icon: 'error',
      });
      return null;
    });
}

async function handleResponseAsync(t, router, url, jsonString, back, success, failure) {
  try {
    let response;
    if (jsonString) {
      const dataObject = JSON.parse(jsonString);
      dataObject.user_id = getId();
      const data = JSON.stringify(dataObject);
      response = await axios.post(url, data);
    } else {
      response = await axios.get(url);
    }

    if (response.data.success) {
      if (router && back) {
        router.push(back);
      }
      if (success) {
        Swal.fire({
          title: t(success),
          icon: 'success',
        });
      }
      return response.data;
    }
    console.error(response);
    Swal.fire({
      title: t(failure),
      icon: 'error',
    });
    return response.data ? response.data : response.message;
  } catch (error) {
    console.error('There was an error processing the request:', error);
    Swal.fire({
      title: t(failure),
      icon: 'error',
    });
    return null;
  }
}

export function fetchList(t, url, data = null, router = null) {
  return handleResponse(t, router, url, data, null);
}

export function fetchGroup(t, url, data, router = null) {
  return handleResponse(t, router, url, data, null, null, 'failure');
}

export function moveGroup(t, url, mainId, nextId, router = null) {
  const data = JSON.stringify({ mainId, nextId });
  return handleResponse(t, router, url, data, null, null, 'failure');
}

export function fetchData(t, url, id, router = null) {
  const data = JSON.stringify({ id });
  return handleResponse(t, router, url, data, null, null, 'failure');
}

export function insertData(t, url, data, router = null, back = null) {
  return handleResponse(t, router, url, data, back, 'addSuccessful', 'addFailure');
}

export function updateData(t, url, data, router = null, back = null) {
  return handleResponse(t, router, url, data, back, 'editSuccessful', 'editFailed');
}

export function insertDataWithFile(t, url, data, file, router = null, back = null) {
  return handleResponseWithFile(t, router, url, data, back, 'addSuccessful', 'addFailure', file);
}

export function updateDataWithFile(t, url, data, file, router = null, back = null) {
  return handleResponseWithFile(t, router, url, data, back, 'editSuccessful', 'editFailed', file);
}
export async function fetchListAsync(t, url, data = null, router = null) {
  return handleResponseAsync(t, router, url, data, null);
}

export async function deleteData(t, url, id, router = null, back = null, dialog = true) {
  if (!dialog) {
    const data = JSON.stringify({ id });
    return handleResponseAsync(
      t,
      router,
      url,
      data,
      back,
      'deletionSuccessful',
      'deletionFailed',
    );
  }
  try {
    const result = await Swal.fire({
      icon: 'question',
      title: t('confirmDeletion'),
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: t('confirm'),
      cancelButtonText: t('cancel'),
    });

    if (result.isConfirmed) {
      const data = JSON.stringify({ id });
      return await handleResponseAsync(
        t,
        router,
        url,
        data,
        back,
        'deletionSuccessful',
        'deletionFailed',
      );
    }
    return null;
  } catch (error) {
    console.error('Error handling delete confirmation:', error);
    return null;
  }
}
